// NPM Imports
import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Loader } from "@revvsales/components";

// Component Imports
import EmailLookUp from "./emailLookUp";
import OrgListing from "./orgListing";
import PendingInviteForm from "./pendingInviteForm";
import SignInWrapper from "./signInWrapper";
import SignInForm from "./signInForm";
import SignInGoogle from "./signInGoogle";
import SignInSaml from "./signInSaml";

// CSS Imports
import signIn from "./signin.module.scss";

// Internal Imports
import { GlobalUtils } from "../../utils";

// Destructuring
const { removeCookie } = GlobalUtils;

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: "emailVerify",
      domains: [],
      email: "",
      invitedDomains: [],
      isVerified: true,
      loader: false,
      ociNewSignUp: false,
      ociReSignUp: false,
      selectedDomain: "",
      suggestion: "",
      signUpInfo: "",
    };
  }

  componentDidMount() {
    document.title = "Sign In - Revv App";

    // Handle new user getting redirected to signin page due to invite flow
    const isRedirectedFromSignup = this.props.location.state; // eslint-disable-line react/prop-types
    if (isRedirectedFromSignup) {
      this.setState({
        ...isRedirectedFromSignup,
      });
    }

    // Note by ajai: temp code to handle amplitude removal from app, the below codes to be removed on Jan 1 2022
    removeCookie("amplitudeData");
    removeCookie("anonymous_user_id");
  }

  _toggleSignInView = state => {
    this.setState(state);
  };

  _decideSignInView = () => {
    const {
      domains,
      email: userEmail,
      invitedDomains,
      isVerified,
      ociNewSignUp,
      ociReSignUp,
      selectedDomain,
      signUpInfo,
      suggestion,
    } = this.state;

    const showOrgInfo = (domains && domains.length > 1) || ociReSignUp;
    const email = userEmail && userEmail.toLocaleLowerCase();

    switch (this.state.currentView) {
      case "emailVerify":
        return <EmailLookUp toggleView={this._toggleSignInView} />;

      case "orgListing":
        return (
          <OrgListing
            data={{
              domains,
              email,
              invitedDomains,
              ociNewSignUp,
              ociReSignUp,
              selectedDomain,
              signUpInfo,
              suggestion,
            }}
            toggleView={this._toggleSignInView}
          />
        );

      case "password":
        return (
          <SignInWrapper
            data={{
              domains,
              email,
              isVerified,
              ociReSignUp,
              selectedDomain,
              showOrgInfo,
            }}
            toggleView={this._toggleSignInView}>
            <SignInForm />
          </SignInWrapper>
        );

      case "pendingInvite":
        return (
          <PendingInviteForm
            data={{ email, invitedDomains, selectedDomain, suggestion }}
            toggleView={this._toggleSignInView}
          />
        );

      case "google": {
        return (
          <SignInWrapper
            data={{
              email,
              selectedDomain,
              domains,
              ociReSignUp,
              showOrgInfo,
            }}
            toggleView={this._toggleSignInView}>
            <SignInGoogle />
          </SignInWrapper>
        );
      }

      case "saml":
        return (
          <SignInWrapper
            data={{ domains, email, ociReSignUp, selectedDomain, showOrgInfo }}
            toggleView={this._toggleSignInView}>
            <SignInSaml />
          </SignInWrapper>
        );

      default:
        return <EmailLookUp toggleView={this._toggleSignInView} />;
    }
  };

  render() {
    const { loader } = this.state;

    if (loader) {
      return <Loader />;
    }

    const query = new URLSearchParams(window.location.search);
    const signUpURL =
      query.get("from") === "slack"
        ? `/signup${window.location.search}`
        : "/signup/";
    return (
      <Fragment>
        {/** BODY SECTION */}
        {this._decideSignInView()}

        {/** FOOTER SECTION */}
        <Fragment>
          <div className={signIn.termsWrapper}>
            By signing in, you agree to our
            <a
              href="/termsofuse.html"
              target="_blank"
              className={signIn.externalLink}>
              Terms of Use
            </a>{" "}
            &
            <a
              href="/privacy.html"
              target="_blank"
              className={signIn.externalLink}>
              Privacy Policy
            </a>
          </div>
          <div className={signIn.signupLinkWrapper}>
            Don&apos;t have an account?
            <Link to={signUpURL} className={signIn.signupLink}>
              Sign up for free
            </Link>
          </div>
        </Fragment>
      </Fragment>
    );
  }
}

export default withRouter(SignIn);
